import React from 'react';
import { Breadcrumb, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './style.scss';
import { useBreadcrumb } from '../../services/breadcrumb-services/BreadcrumbContext';

const PageHeader = () => {
    const { customName } = useBreadcrumb();
    const location = useLocation();
    
    const pathSegments = location.pathname.split('/').filter(Boolean); // e.g. ['transactions', '43fa764d-...']
    
    const isDetailPage = pathSegments.length === 2;
    const basePath = pathSegments[0] || ''; // 'transactions'
    const basePathCapitalized = basePath.charAt(0).toUpperCase() + basePath.slice(1);

    return (
        <div className="page-header">
            <Col lg="6" className="align-self-center">
                {/* <h2>
                    {isDetailPage
                        ? `${basePathCapitalized} > ${customName || pathSegments[1]}`
                        : basePathCapitalized}
                </h2> */}
                <Breadcrumb>
                    {/* <Breadcrumb.Item>
                        <Link to="/">Main</Link>
                    </Breadcrumb.Item> */}
                    <Breadcrumb.Item>
                        <Link to={`/${basePath}`}>{basePathCapitalized}</Link>
                    </Breadcrumb.Item>
                    {isDetailPage && (
                        <Breadcrumb.Item active>
                            {customName || pathSegments[1]}
                        </Breadcrumb.Item>
                    )}
                </Breadcrumb>
            </Col>
        </div>
    );
};

export default PageHeader;
